import { useEffect, useRef, useState } from "react";
import { Divider, Fade, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";
import { Edit } from "@mui/icons-material";

import { ITrainingSheetModalMethods } from "../../components/training-sheet-modal";
import { PageHeader, TrainingSheetModal } from "../../components";
import { useTraining } from "../../contexts";
import * as s from "./styles";

const TrainingSheet = () => {
  const history = useHistory();
  const { training } = useTraining();
  const [tooltipIsVisible, setTooltipIsVisible] = useState(true);
  const trainingSheetModalRef = useRef<ITrainingSheetModalMethods | null>(null);

  useEffect(() => {
    setTimeout(() => {
      setTooltipIsVisible(false);
    }, 3000);
  }, []);

  return (
    <>
      <TrainingSheetModal ref={trainingSheetModalRef} />
      <Fade in timeout={1000}>
        <s.PageContainer>
          <PageHeader
            label={"Ficha do aluno"}
            handleBackPress={() => history.goBack()}
          />
          <s.PageContent>
            <Typography variant="caption" color="gray">
              Objetivo
            </Typography>
            <Typography>{training?.objective || "-"}</Typography>
            <Divider sx={{ mt: 1.5, mb: 1.5 }} />
            <Typography variant="caption" color="gray">
              Observações
            </Typography>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {training?.observation || "-"}
            </Typography>
            <Divider sx={{ mt: 1.5, mb: 1.5 }} />

            <Tooltip
              title={`Editar ficha`}
              placement="top-end"
              arrow
              open={tooltipIsVisible}
            >
              <s.EditTrainingSheetButton
                color="primary"
                variant="circular"
                onClick={() => trainingSheetModalRef.current?.handleOpen()}
              >
                <Edit />
              </s.EditTrainingSheetButton>
            </Tooltip>
          </s.PageContent>
        </s.PageContainer>
      </Fade>
    </>
  );
};

export default TrainingSheet;
